import { LOGIN_ERROR_MESSAGES } from 'auth/constants/LoginErrorMessages';
import { GENERIC_MESSAGES } from 'shared/constants/GenericMessages';
import { ApiError } from 'shared/http';

export class LoginError {
  public errorMsg: string;
  private status: number;

  constructor(error: ApiError, statusCode?: number) {
    this.errorMsg = error.message;
    this.status = statusCode || error.status;
  }

  get message(): string {
    switch (this.status) {
      case 401:
        return LOGIN_ERROR_MESSAGES.BadCredentials;
      default:
        return (
          LOGIN_ERROR_MESSAGES[this.errorMsg as keyof typeof LOGIN_ERROR_MESSAGES] ||
          GENERIC_MESSAGES.genericError
        );
    }
  }
}
